module.exports = "/images/FilledTOS.svg?db265c629af58e8d8958e7ac76acdfc5";